import { useEffect } from 'react';
import { AxiosError } from 'axios';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType
} from 'react-router-dom';
import * as Sentry from '@sentry/react';

export const sentryInit = () => {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN as string,
        integrations: [
            // TODO: migrate to Sentry.reactRouterBrowserTracingIntegration (react-router v7); pre-existing deprecation surfaced by the typescript-eslint bump
            // eslint-disable-next-line @typescript-eslint/no-deprecated, sonarjs/deprecation
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            }),
            Sentry.replayIntegration()
        ],
        tracesSampleRate: 1,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            'localhost',
            /newo\.ai/,
            /^https:\/\/portal\.newo\.ai/
        ],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1,
        beforeSend(event, hint) {
            const error = hint.originalException;
            if (error instanceof AxiosError) {
                // eslint-disable-next-line unicorn/no-null
                return null;
            }
            return event;
        }
    });
};
